import { WSSelectOption } from "@wingspanhq/fe-component-library";
import { AccountingVendor } from "@wingspanhq/wingspan-api-sdk";
import sortBy from "lodash/sortBy";
import { selectorAccountingCustomerLabel } from "./selectorAccountingCustomerLabel";

/**
 * QuickBooks vendors as `WSSelect` options, sorted by label. The v3 counterpart
 * of `selectQuickbooksUserOptions` for the vendor side; the option value is the
 * reference id the payee mapping write stores (`quickbooksVendorId`).
 *
 * v1 grouped and de-duplicated the raw QuickBooks list client-side
 * (`getSortedAndGroupedQuickbooksUserList`) because the sync returned repeated
 * rows. v3 serves the reconciled reference data, so the list is used as-is.
 */
export const selectorAccountingVendorOptions = (
  vendors?: AccountingVendor[]
): WSSelectOption[] =>
  sortBy(
    (vendors || []).map(vendor => ({
      label: selectorAccountingCustomerLabel(vendor),
      value: vendor.id,
      searchText: [vendor.displayName, vendor.companyName, vendor.email]
        .filter(Boolean)
        .join(" ")
    })),
    option => option.label.toLocaleLowerCase()
  );
